export default "__VITE_ASSET__B9zfpLAt__"